import { ViewProps, video } from "shared/types/Report";
import { Button, ButtonReversed } from "shared/components/Button";
import useVideoView from "features/homework/hooks/useVideoView";
import VideoTable from "./VideoTable";
import Modal from "shared/components/Modal";
import LoadingWithProgressBar from "shared/components/Loading";
import FilePreviewModal from "shared/components/FilePreviewModal";
import VideoBatchView from "./VideoBatchView";
import { EditorShell, EditorHeader, EditorTitle, EditorDesc, ActionBar, ActionHint, CountBadge } from "../homeworkUi";

const VideoView = ({list, path, setList}:ViewProps<video>) => {
    const {onAddClickHandler, onChangeHandler, onSelectHandler, onSelectAllClickHandler, selectedList, onDeleteClickHandler, isSaveSucceed, onSuccessModalConfirmHandler, showProgress, uploadFileName, progress, videoInputRefs,
        onVideoInputClickHandler, onVideoChangeHandler, onRegisterReportClickHandler, selectedFile, onDeleteVideoClickHandler, onFileModalCloseClickHandler, onFileClickHandler, isOpenBatchView, onBatchViewCancelClickHandler, onBatchViewOpenClickHandler, onSelectReadOnlyClickHandler} = useVideoView(list, setList, path);
    const renderButtons = () =>{
        if (selectedList.length) {
            return (
                <ActionBar>
                    <ActionHint>선택한 {selectedList.length}개 항목을 삭제한 뒤 저장을 눌러 주세요</ActionHint>
                    <ButtonReversed name="삭제" onButtonClick={onDeleteClickHandler}/>
                </ActionBar>
            );
        }
        return (
            <ActionBar>
                <ButtonReversed name="일괄등록" onButtonClick={onBatchViewOpenClickHandler} />
                <Button name="저장" onButtonClick={onRegisterReportClickHandler}/>
            </ActionBar>
        );
    }
    return(
        <EditorShell>
            <VideoBatchView list={list} setList={setList} isOpen={isOpenBatchView} onCancelClickHandler={onBatchViewCancelClickHandler} path={path}/>
            {showProgress ? <LoadingWithProgressBar title="파일 업로드" subTitle={uploadFileName} progress={progress}/> : null}
            <Modal isOpen={isSaveSucceed} onClose={onSuccessModalConfirmHandler} title="저장 성공" content="저장에 성공하였습니다"/>
            <FilePreviewModal isOpen={selectedFile.url ? true : false} type={selectedFile.type} value={selectedFile.url} onDeleteClickHandler={onDeleteVideoClickHandler} onCancelClickHandler={onFileModalCloseClickHandler}/>
            <EditorHeader>
                <div>
                    <EditorTitle>영상 등록</EditorTitle>
                    <EditorDesc>행을 추가하거나 일괄등록으로 여러 영상을 한 번에 넣을 수 있습니다.</EditorDesc>
                </div>
                <CountBadge>{list.length}개</CountBadge>
            </EditorHeader>
            <VideoTable list={list} onAddClickHandler={onAddClickHandler} onChangeHandler={onChangeHandler} onSelectHandler={onSelectHandler} selectedList={selectedList} onSelectAllClickHandler={onSelectAllClickHandler} videoInputRefs={videoInputRefs} onVideoChangeHandler={onVideoChangeHandler} onVideoInputClickHandler={onVideoInputClickHandler} onFileClickHandler={onFileClickHandler} onSelectReadOnlyClickHandler={onSelectReadOnlyClickHandler}/>
            {renderButtons()}
        </EditorShell>
    )
}

export default VideoView;